import React from 'react';
import styled, { keyframes } from 'styled-components';
import { HeartFilled } from '@ant-design/icons';

// Beating heart animation
const heartbeat = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.25); }
  100% { transform: scale(1); }
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.$padding || '40px'};
  gap: 12px;
  min-height: ${props => props.$fullHeight ? 'calc(100vh - 200px)' : 'auto'};
`;

const HeartIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.$color || '#262626'};
  font-size: ${props => props.$size || '32px'};
  animation: ${heartbeat} 0.4s ease-in-out infinite;
`;

const LoadingText = styled.span`
  color: #666;
  font-size: 14px;
  font-weight: 500;
`;

/**
 * HeartLoader - A beating black heart loading indicator
 * 
 * @param {string} size - Size of the heart icon (default: '32px')
 * @param {string} color - Color of the heart (default: '#262626')
 * @param {string} text - Optional loading text to display
 * @param {string} padding - Padding around the loader (default: '40px')
 * @param {boolean} fullHeight - Whether to take full viewport height for centering (default: false)
 * @param {object} style - Optional additional styles
 */
const HeartLoader = ({ 
  size = '32px', 
  color = '#262626', 
  text,
  padding = '40px',
  fullHeight = false,
  style = {} 
}) => {
  return (
    <LoaderContainer $padding={padding} $fullHeight={fullHeight} style={style}>
      <HeartIcon $size={size} $color={color}>
        <HeartFilled />
      </HeartIcon>
      {text && <LoadingText>{text}</LoadingText>}
    </LoaderContainer>
  );
};

export default HeartLoader;
